import DataStore from '@/engine/stores/data-store';

class AdminUsersDataStore extends DataStore {

}

export default new AdminUsersDataStore();
